export default __webpack_public_path__ + "static/media/lotusiotop.5ee93728.png";